import { render } from "./DownloadsView.vue?vue&type=template&id=a3f46ab6"
import script from "./DownloadsView.vue?vue&type=script&lang=js"
export * from "./DownloadsView.vue?vue&type=script&lang=js"

import "./DownloadsView.vue?vue&type=style&index=0&id=a3f46ab6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__